import React from "react";
import SupportFeedbackDetailPage from "../dashboard/SupportFeedbackDetailPage";

export default function SuperAdminFeedbackDetailPage({
  backPath = "/super-admin/feedback",
}) {
  return (
    <SupportFeedbackDetailPage
      mode="super-admin"
      backPath={backPath}
      backLabel="Feedback Management"
    />
  );
}
